import React, { FC } from "react";

// images
import customerSupportTeamMobile from "assets/images/customer-support/be-support-client-team.png";
import customerSupportTeamDesktop from "assets/images/customer-support/be-support-client-team@2x.png";

// UI
import { Box } from "@UI/Components/Box/Box";
import { Image } from "@UI/Components/Image/Image";
import { Flex } from "@UI/Components/Flex/Flex";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Link } from "@UI/Components/Link/Link";
import useMediaQuery from "@UI/hooks/useMediaQuery";

// i18n
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import useI18n from "@I18n/hooks/useI18n";

export const ReachOutToUs: FC = () => {
  const { isMobile } = useMediaQuery();
  const { formatMessage } = useI18n();

  return (
    <Box
      background="sand.100"
      rounded="xl"
      padding={["6", null, "12"]}
      textAlign={["center", null, "start"]}
      position="relative"
      marginTop={{ base: "4", sm: "12", md: "32", lg: "48" }}
    >
      <Flex
        justifyContent="center"
        marginBottom={[4, 4, 0]}
        position={[null, null, "absolute"]}
        alignSelf="baseline"
        bottom="0"
        left="12"
      >
        <Image
          src={
            isMobile ? customerSupportTeamMobile : customerSupportTeamDesktop
          }
          boxSize={[24, 24, 36, 60]}
          position="relative"
          bottom="0"
        />
      </Flex>
      <Box paddingLeft={[null, null, "33%"]}>
        <Heading as="h4" fontSize="xl" marginBottom="2" lineHeight="1">
          <FormattedMessage {...messages.cantFindTheAnswerToYourQuestion} />
        </Heading>
        <Text>
          <FormattedMessage
            {...messages.contactUsViaOurPhoneOrEmail}
            values={{
              phone: (
                <Link
                  href={`tel:${formatMessage(messages.contactUsPhoneNumber)}`}
                  color="pink.500"
                  textDecoration="underline"
                >
                  <FormattedMessage {...messages.contactUsPhoneNumber} />
                </Link>
              ),
              email: (
                <Link
                  href="mailto: contact@ringtwice.com"
                  color="pink.500"
                  textDecoration="underline"
                >
                  contact@ringtwice.com
                </Link>
              ),
            }}
          />
        </Text>
      </Box>
    </Box>
  );
};
